export default {
  async fetch({ store, route }) {
    store.commit('head/RESTORE_DEFAULT_VALUE', route);
  },
};
